var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,5.724V2c0-.552-.447-1-1-1s-1,.448-1,1v2.366L14.797,.855c-1.699-1.146-3.895-1.146-5.594,0L2.203,5.579c-1.379,.931-2.203,2.48-2.203,4.145v9.276c0,2.757,2.243,5,5,5h3.913c.822,0,1.572-.516,1.867-1.283l1.29-3.358c.118-.307,.077-.653-.109-.925s-.495-.434-.824-.434h-2.756c-.19,0-.284-.121-.323-.192-.039-.072-.089-.217,.007-.364l4.957-7.369c.062-.094,.204-.097,.271-.009,.032,.044,.041,.093,.024,.146l-1.369,4.497c-.092,.303-.035,.632,.153,.887,.188,.255,.487,.405,.804,.405h2.869c.097,0,.154,.052,.186,.096,.03,.043,.061,.114,.029,.206l-1.74,5.045c-.211,.61-.113,1.288,.262,1.814,.374,.525,.983,.839,1.629,.839h2.861c2.757,0,5-2.243,5-5V9.724c0-1.581-.743-3.058-2-4Zm0,13.276c0,1.654-1.346,3-3,3h-2.861l1.74-5.045c.234-.68,.126-1.435-.291-2.02-.418-.585-1.096-.935-1.814-.935h-1.52l.977-3.206c.201-.663,.08-1.362-.332-1.918-.412-.557-1.047-.876-1.739-.876-.729,0-1.405,.364-1.803,.967l-4.96,7.374c-.475,.729-.511,1.656-.097,2.42,.415,.764,1.212,1.239,2.081,1.239h1.301l-.769,2h-3.913c-1.654,0-3-1.346-3-3V9.724c0-.999,.494-1.929,1.322-2.487L10.322,2.513c1.02-.688,2.336-.688,3.355,0l7,4.724c.828,.558,1.322,1.488,1.322,2.487v9.276Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7d56207d83e12663f494ca9de116e28b.svg";
export { ForwardRef as ReactComponent };